import React from "react";
import { CheckCircle } from "react-feather";
import { useTranslation } from "react-i18next";

export default function PasswordSuccess() {
  const { t } = useTranslation();

  return (
    <div className="container--sm card card--panel text-center">
      <div className="icon-circle icon-circle--success">
        <CheckCircle size={42} />
      </div>

      <h2 className="title">{t("pwd_success_title")}</h2>

      <p className="text text--main">{t("pwd_success_main")}</p>

      <p className="text text--muted">{t("pwd_success_hint")}</p>
    </div>
  );
}
